import { environment } from '../../../../../environments/environment.staging';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Lilate, LilateStatus } from '../../model/lilate.model';
import { LilateService } from '../../service/lilate.service';

@Component({
  selector: 'app-cancel-lilate',
  templateUrl: './cancel-lilate.component.html',
  styleUrls: ['./cancel-lilate.component.scss']
})
export class CancelLilateComponent implements OnInit {
  @Input() lilate: Lilate;
  @Output() close = new EventEmitter();

  constructor(
    private lilateService: LilateService
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.close.emit();
  }

  cancelLilate() {
    this.lilateService.patch({ status : LilateStatus.cancelled_by_teacher }, this.lilate.id).subscribe(
      () => {
        this.closeModal();
      }
    );
  }
}
